import React from 'react';
import {
  AbstractField,
  Field,
  FieldAnswer,
  FieldType,
  InformationPageField,
  LongTextField,
  MultipleChoiceField,
  ParticipantSource,
  ShortTextField,
  SingleChoiceField,
} from '@app/api';
import { MultipleChoiceFieldForm } from './FormField/MultipleChoicesFieldForm';
import { SingleChoiceFieldForm } from './FormField/SingleChoiceFieldForm';
import { TextFieldForm } from './FormField/TextFieldForm';
import { ShortText } from './Fields/ShortText';
import { LongText } from './Fields/LongText';
import { InformationPage } from './Fields/InformationPage';

export type FormParticipation = {
  id?: string;
  sessionId: string;
  participant: {
    id?: string;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    source?: ParticipantSource;
  };
};

export enum SubmitType {
  CONTINUE = 'continue',
  DONE = 'done',
}

interface RenderFieldOptions<T> {
  field: T;
  onSubmit: (answer?: FieldAnswer) => any;
  submitType?: SubmitType;
  formResponseId?: string;
}

export interface FieldConfig<T extends AbstractField = Field> {
  renderField: (options: RenderFieldOptions<T>) => React.ReactElement;
}

type FieldsConfig = {
  [FieldType.MULTIPLE_CHOICE]: FieldConfig<MultipleChoiceField>;
  [FieldType.SINGLE_CHOICE]: FieldConfig<SingleChoiceField>;
  [FieldType.SHORT_TEXT]: FieldConfig<ShortTextField>;
  [FieldType.LONG_TEXT]: FieldConfig<LongTextField>;
  [FieldType.INFORMATION_PAGE]: FieldConfig<InformationPageField>;
};

export const fieldConfigurations: FieldsConfig = {
  [FieldType.SHORT_TEXT]: {
    renderField: ({
      field,
      onSubmit,
      submitType,
    }: RenderFieldOptions<ShortTextField>) => (
      <TextFieldForm field={field} onSubmit={onSubmit} submitType={submitType}>
        <ShortText field={field} />
      </TextFieldForm>
    ),
  },
  [FieldType.LONG_TEXT]: {
    renderField: ({
      field,
      onSubmit,
      submitType,
    }: RenderFieldOptions<LongTextField>) => (
      <TextFieldForm field={field} onSubmit={onSubmit} submitType={submitType}>
        <LongText field={field} />
      </TextFieldForm>
    ),
  },
  [FieldType.MULTIPLE_CHOICE]: {
    renderField: ({
      field,
      onSubmit,
      submitType,
    }: RenderFieldOptions<MultipleChoiceField>) => (
      <MultipleChoiceFieldForm
        field={field}
        onSubmit={onSubmit}
        submitType={submitType}
      />
    ),
  },
  [FieldType.SINGLE_CHOICE]: {
    renderField: ({
      field,
      onSubmit,
      submitType,
    }: RenderFieldOptions<SingleChoiceField>) => (
      <SingleChoiceFieldForm
        field={field}
        onSubmit={onSubmit}
        submitType={submitType}
      />
    ),
  },
  [FieldType.INFORMATION_PAGE]: {
    renderField: ({
      field,
      onSubmit,
      submitType,
    }: RenderFieldOptions<InformationPageField>) => (
      <InformationPage
        field={field}
        onSubmit={onSubmit}
        submitType={submitType}
      />
    ),
  },
};
